import { FastAverageColor, FastAverageColorResult } from 'fast-average-color';

export const getAverageColor = async (imageUrl: string): Promise<string | null> => {
	const fac = new FastAverageColor();
	const image = new Image();
	image.src = imageUrl;
	image.crossOrigin = 'anonymous';

	const color = await new Promise<FastAverageColorResult>((resolve, reject) => {
		image.onload = async () => {
			try {
				const result = await fac.getColorAsync(image, {
					defaultColor: [255, 96, 0, 255],
					ignoredColor: [
						[255, 255, 255],
						[0, 0, 0],
					],
				});

				resolve(result);
			} catch (e) {
				reject(e);
			}
		};

		image.onerror = reject;
	});

	const lightThreshold = 210;
	const threshold = 0.2126 * color.value[0] + 0.7152 * color.value[1] + 0.0722 * color.value[2];

	return threshold > lightThreshold ? null : color.hex;
};
